'use client';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@repo/ui';
import { useSearchParams } from 'next/navigation';
import type * as React from 'react';

import { AppleLinkButton } from './apple-link-button';
import { ErrorCard } from './error-card';
import { GoogleLinkButton } from './google-link-button';
import { LinkingCard } from './linking-card';
import { SuccessCard } from './success-card';
import { useLinkOauth } from './use-link-oauth';

export function ConnectTelegramTemplate(): React.ReactNode {
  const searchParams = useSearchParams();
  const token = searchParams.get('token');
  const step = searchParams.get('step');
  const { status, errorMessage } = useLinkOauth(token, step);

  if (!token) {
    return (
      <CenteredLayout>
        <ErrorCard message="Missing session token. Please try again from Telegram." />
      </CenteredLayout>
    );
  }

  if (status === 'linking') {
    return (
      <CenteredLayout>
        <LinkingCard />
      </CenteredLayout>
    );
  }
  if (status === 'success') {
    return (
      <CenteredLayout>
        <SuccessCard />
      </CenteredLayout>
    );
  }
  if (status === 'error') {
    return (
      <CenteredLayout>
        <ErrorCard message={errorMessage} />
      </CenteredLayout>
    );
  }

  const callbackURL = `/connect/telegram?token=${token}&step=complete`;

  return (
    <CenteredLayout>
      <Card className="w-full max-w-sm">
        <CardHeader className="text-center">
          <CardTitle className="text-xl">Connect Your Account</CardTitle>
          <CardDescription>
            Link your Google or Apple account to access your data on the app and website.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-3">
          <GoogleLinkButton callbackURL={callbackURL} />
          <AppleLinkButton callbackURL={callbackURL} />
        </CardContent>
      </Card>
    </CenteredLayout>
  );
}

function CenteredLayout({ children }: { children: React.ReactNode }): React.ReactNode {
  return <div className="flex min-h-screen items-center justify-center p-4">{children}</div>;
}
